import { generateTableSlice } from "./sliceTable";

const sliceAppointmentTable = generateTableSlice("appointment");

export const ActionsAppointmentTable = sliceAppointmentTable.actions;
export const ReducerAppointmentTable = sliceAppointmentTable.reducer;
